(function($, THERMOS, cssua){
	const a = 'is-active';
	const slideSpeed = '300';

	const noContextMenu = () => {
		$('.js-noContext, .mod-image').each((idx, ele) => {
			$(ele).on('contextmenu', () => {
				return false;
			});
		});
	};
	const addNewIcon = () => {
		const currentDate = new Date();
		const newIcon = '<span class="mod-new">NEW</span>';

		$('.js-checkDate').each((idx, ele) => {
			let targetDate = new Date($(ele).attr('datetime'));
			let diff = currentDate - targetDate;
			let diffDay = diff / 86400000;

			if(diffDay < 30) {
				$(ele).prepend(newIcon);
			}
		});
	};
	const modSelect = () => {
		$('.mod-select').hover(
			(e) => {
				$(e.currentTarget).addClass(a);
				$(e.currentTarget).find('.mod-select-body').stop().slideDown(slideSpeed);
			},
			(e) => {
				$(e.currentTarget).removeClass(a);
				$(e.currentTarget).find('.mod-select-body').stop().slideUp(slideSpeed);
			}
		);
	};
	const infoYearGenerator = () => {
		const $body = $('.js-selectYear-body');
		const $latestY = $('.info-selectYear_latest');
		const en = THERMOS.va.isEnglish;
		if($body.length > 0 && $latestY.length > 0) {
			const startY = 2013;
			const latestY = Number($latestY.text());
			const addText = en ? '' : '年';
			let html = '';

			for(let i = latestY; i >= startY; i--) {
				if(i !== 2014 && i !== 2015) {
					html += `<li><a href="/info/${i}/">${i}${addText}</a></li>`;
				}
			}
			$body.append(html);
		}
	};
	const trimTopicpath = () => {
		if(THERMOS.va.pathname.indexOf('/detail/') !== -1) {
			const $path = $('.mod-topicPath-li:last-child').find('.mod-topicPath-span');
			const rawText = $path.text();
			const cnt = 70;
			if(rawText.length > cnt) {
				$path.text(rawText.substring(0, cnt) + '...');
			}
		}
	};
	const trimNewsListTitle = () => {
		if($('.mod-newsList-title')[0]) {
			$('.mod-newsList-title').each((idx, ele) => {
				const rawText = $(ele).text();
				const cnt = 70;
				if(rawText.length > cnt) {
					$(ele).text(rawText.substring(0, cnt) + '...');
				}
			});
		}
	};
	const setShareLinks = () => {
		if (document.querySelectorAll('.mod-share')) {
			let shareBtnHTML = '<li><a href="https://www.facebook.com/sharer/sharer.php?u=#link" target="_blank" rel="noopener" class="js-share-item">' +
			'<svg aria-label="Facebookでシェアする"><use xlink:href="/common/svg/sprite.svg#facebook" /></svg></a></li>' +
			'<li><a href="https://twitter.com/share?url=#link&related=twitterapi%2Ctwitter&text=#text" target="_blank" rel="noopener" class="js-share-item">'+
			'<svg aria-label="Xでポストする"><use xlink:href="/common/svg/sprite.svg#x" /></svg></a></li>' +
			'<li><a href="http://line.me/R/msg/text/?#text#link" target="_blank" rel="noopener" class="js-share-item">'+
			'<svg aria-label="LINEで送る"><use xlink:href="/common/svg/sprite.svg#line" /></svg></a></li>';

			document.querySelectorAll('.mod-share').forEach(ele => {
				ele.innerHTML = shareBtnHTML;
			});
		}
		document.querySelectorAll('.js-share-item').forEach(ele => {
			const url = encodeURIComponent(document.URL);
			const title = encodeURIComponent(document.title);
			ele.setAttribute('href', ele.getAttribute('href').replace(/#link/ig, url).replace(/#text/ig, title));
		});
	};
	const historyProductsCurrent = () => {
		$('.company-history-products-menu-a').each(function(){
			var $this = $(this);
			var href = $(this).attr('href');

			if (THERMOS.va.pathname.indexOf(href) !== -1) {
				$this.addClass(a);
			}
		});
	};

	if (THERMOS.va.pathname.indexOf('/info/') !== -1) {
		infoYearGenerator();
	}
	modSelect();
	noContextMenu();
	addNewIcon();
	trimTopicpath();
	trimNewsListTitle();
	setShareLinks();
	historyProductsCurrent();

})(window.jQuery, window.THERMOS, window.cssua);
